const ShippingLaneFilterType = {
	FLAG: "flag",
	SHIP_TYPE: "shiptype"
};
export default ShippingLaneFilterType;
